/**
 * Web Style Import
 *
 */

import './style/dnb-modal.scss'
